module.exports = __webpack_public_path__ + "d5b5621cff194b0f8749df9cea00ab1e.png";